// extracted by mini-css-extract-plugin
module.exports = {"Iframe":"styles_Iframe__9mZBC"};